import gql from 'graphql-tag';

export const GET_CLOSE_REASONS_OPTIONS = gql`
  query GetCloseReasonsOptions($id: ID!, $type: BPFCloseReasonType!) {
    bpf {
      options: closeReasonsOptions(id: $id, type: $type) {
        label
        value
      }
    }
  }
`;
